import { render, staticRenderFns } from "./course_knowledge.vue?vue&type=template&id=b2b02e4a&scoped=true&"
import script from "./course_knowledge.vue?vue&type=script&lang=js&"
export * from "./course_knowledge.vue?vue&type=script&lang=js&"
import style0 from "./course_knowledge.vue?vue&type=style&index=0&id=b2b02e4a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b02e4a",
  null
  
)

export default component.exports